import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { AdditionalCountsDto, AdditionalInfoCountsDto, CadBimCountsDto, Client as CatalogApi, CatalogInformationCountsDto, CatalogItemsCountsDto, DocumentCountsDto, ImageVideoCountsDto, LinkCountsDto } from '@interfaces/HttpClient/CatalogApiModels';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class OrcaAdminContentService {

	constructor(
		private catalogApi: CatalogApi,
		private requestService: RequestService) { }

	async getCatalogItemsCount(): Promise<CatalogItemsCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsItemsCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogItemsWithPlusInformationAdditionalCount(): Promise<AdditionalCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsAdditionalCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogItemsInformationCount(): Promise<CatalogInformationCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsItemsInformationCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogsAdditionalInfoCount(): Promise<AdditionalInfoCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsAdditionalInfoCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogsImageVideoCount(): Promise<ImageVideoCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsImageVideoCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogsDocumentCount(): Promise<DocumentCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsDocumentCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogsCadBimCount(): Promise<CadBimCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsCadBimCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getCatalogsLinkCount(): Promise<LinkCountsDto> {
		try {
			return firstValueFrom(this.catalogApi.orcaAdminContent_GetCatalogsLinkCount());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}
}
